import React, { useState } from "react";
import { FloatingLabel, Select } from "react-input-textboxs";

export default function AddUser(props) {
  const {
    formValue: {
      loginId,
      employeeName,
      lang,
      usertype,
      primary_lang,
      password,
      user_products,
      user_team,
    },
    userLanguages,
    userTypes,
    userProducts,
    userTeams,
  } = props;

  const [otherLanguages, setOtherLanguages] = useState([]);

  function filterLanguages(value) {
    otherLanguages.push(value);
    setOtherLanguages(
      userLanguages.filter((value) => {
        return !otherLanguages.includes(value);
      })
    );
  }

  const userTypesArray = userTypes.map((item) => {
    return item.type_description;
  });

  const userProductsArray = userProducts.map((item) => {
    return item.Productdesc;
  });

  const userTeamsArray = userTeams.map((item) => {
    return item.TeamName;
  });

  return (
    <div className="add-user-model">
      <div className="add-user-wrapper">
        <h2>Create User</h2>
        <form onSubmit={(e) => [e.preventDefault(), props.handleSubmit()]}>
          <FloatingLabel
            label={"Login Id"}
            type={"text"}
            value={loginId}
            variant="standared"
            onChange={(value) => props.handleChange(value, "loginId")}
          />
          <FloatingLabel
            label={"Password"}
            type={"password"}
            value={password}
            variant="standared"
            onChange={(value) => props.handleChange(value, "password")}
          />
          <FloatingLabel
            label={"Employee Name"}
            type={"text"}
            value={employeeName}
            variant="standared"
            onChange={(value) => props.handleChange(value, "employeeName")}
          />
          <Select
            value={usertype}
            onChange={(value) => props.handleChange(value, "usertype")}
            multiple
            filter
            label="Select Usertypes...."
            options={userTypesArray}
          />
          <Select
            value={user_products}
            onChange={(value) => props.handleChange(value, "user_products")}
            multiple
            filter
            label="Select Products...."
            options={userProductsArray}
          />
          <Select
            value={user_team}
            onChange={(value) => props.handleChange(value, "user_team")}
            // multiple
            filter
            label="Select a Team...."
            options={userTeamsArray}
          />
          <Select
            value={primary_lang}
            onChange={(value) => {
              filterLanguages(value);

              props.handleChange(value, "primary_lang");
            }}
            // multiple
            filter
            label="Select a base language...."
            options={userLanguages}
          />
          <Select
            value={lang}
            onChange={(value) => props.handleChange(value, "lang")}
            multiple
            filter
            label="Select other languages...."
            options={otherLanguages}
          />

          <div className="btn-wrapper">
            <button type="submit" className="btn submit-btn">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
